/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * operator to compare the value of a field with a given value
 * @export
 */
export const DatabaseFieldVisibilityOperator = {
    Includes: 'INCLUDES',
    StartsWith: 'STARTS_WITH',
    Equal: 'EQUAL',
    NotEqual: 'NOT_EQUAL',
    LessThan: 'LESS_THAN',
    GreaterThan: 'GREATER_THAN',
    NotEmpty: 'NOT_EMPTY',
    Empty: 'EMPTY'
} as const;
export type DatabaseFieldVisibilityOperator = typeof DatabaseFieldVisibilityOperator[keyof typeof DatabaseFieldVisibilityOperator];


export function DatabaseFieldVisibilityOperatorFromJSON(json: any): DatabaseFieldVisibilityOperator {
    return DatabaseFieldVisibilityOperatorFromJSONTyped(json, false);
}

export function DatabaseFieldVisibilityOperatorFromJSONTyped(json: any, ignoreDiscriminator: boolean): DatabaseFieldVisibilityOperator {
    return json as DatabaseFieldVisibilityOperator;
}

export function DatabaseFieldVisibilityOperatorToJSON(value?: DatabaseFieldVisibilityOperator | null): any {
    return value as any;
}

